import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import * as thunks from './thunks';
import { ChequeListPayload, ChequeManagementState } from './types';
import { chequeListFilter } from './constants';

const initialState: ChequeManagementState = {
  isLoading: false,
  chequeList: [],
  chequeDetails: {},
  chequeListMeta: {},
  chequeListFilterParams: {
    page: 1
  },
  chequeColumn: chequeListFilter
};

const slice = createSlice({
  name: 'cheque-management',
  initialState,
  reducers: {
    chequeFilterParams(state, action: PayloadAction<ChequeListPayload>) {
      state.chequeListFilterParams = action.payload || {};
    },
    toggleChequeColumn: (state, { payload }: PayloadAction<string>) => {
      state.chequeColumn = state.chequeColumn.map((col) =>
        col.value === payload ? { ...col, isVisible: !col.isVisible } : col
      );
    },

    toggleAll: (state) => {
      state.chequeColumn = chequeListFilter;
    }
  },
  extraReducers(builder) {
    builder.addCase(thunks.chequeListThunk.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(thunks.chequeListThunk.rejected, (state) => {
      state.isLoading = false;
    });

    builder.addCase(thunks.chequeListThunk.fulfilled, (state, { payload }) => {
      state.chequeList = payload?.originalData?.data || [];
      state.chequeListMeta = payload?.originalData?.meta || {};
      state.isLoading = false;
    });

    builder.addCase(thunks.chequeDetailsThunk.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(
      thunks.chequeDetailsThunk.fulfilled,
      (state, { payload }) => {
        state.isLoading = false;
        state.chequeDetails = payload?.originalData?.data || {};
      }
    );

    builder.addCase(thunks.chequeDetailsThunk.rejected, (state) => {
      state.isLoading = false;
    });
  }
});

export const reducer = slice.reducer;

export const actions = { ...slice.actions, ...thunks };
